var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_4281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6247 57.9083C36.6536 57.9041 36.6811 57.8981 36.7072 57.8909C36.7179 58.0183 36.728 58.1696 36.7374 58.3486C36.7851 59.2594 36.8097 60.806 36.8097 63.3737C36.8097 73.3655 28.6624 81.5 18.6548 81.5C8.64725 81.5 0.5 73.3655 0.5 63.3737C0.5 57.8708 2.96242 52.737 7.2731 49.2731L7.45991 49.123V48.8834V11.6735C7.45991 5.51826 12.4837 0.5 18.6548 0.5C24.8262 0.5 29.8498 5.51133 29.8498 11.6735V27.1271L26.072 33.2393V11.7591C26.072 7.58754 22.6709 4.1373 18.482 4.2137C14.4363 4.2827 11.1664 7.60783 11.1664 11.6735V50.93L9.73806 52.0563C9.41127 52.3141 9.09182 52.5563 8.7823 52.7909C7.54858 53.7261 6.47073 54.5431 5.69717 55.7711C4.71292 57.3335 4.22789 59.5168 4.22789 63.3808C4.22789 71.3293 10.6836 77.7935 18.6192 77.7935C26.5547 77.7935 33.0105 71.3293 33.0105 63.3808C33.0105 61.3048 32.5688 59.2908 31.7405 57.4557H35.8505C35.9301 57.5954 36.0298 57.7197 36.1608 57.8045C36.2982 57.8936 36.4596 57.9326 36.6247 57.9083Z",
    fill: "#004137",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0796 59.6655V26.5061C21.0796 25.1671 19.9941 24.0815 18.655 24.0815C17.316 24.0815 16.2305 25.1671 16.2305 26.5061V59.6655C16.2305 61.0046 17.316 62.0901 18.655 62.0901C19.9941 62.0901 21.0796 61.0046 21.0796 59.6655Z",
    fill: "#AD3B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9809 63.4807C27.9809 69.3852 22.4828 74.0132 16.3216 72.5228C13.027 71.7313 10.4242 69.157 9.61126 65.8696C8.24209 60.3287 11.8076 55.3013 16.8635 54.3173V54.0962H20.4291V54.3173C24.722 55.1516 27.9809 58.9382 27.9809 63.4807Z",
    fill: "#AD3B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6784 63.3568C56.6511 63.3568 66.3568 53.6511 66.3568 41.6784C66.3568 29.7058 56.6511 20 44.6784 20C32.7058 20 23 29.7058 23 41.6784C23 53.6511 32.7058 63.3568 44.6784 63.3568Z",
    fill: "#F48474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 23C34.2848 23 26 31.2848 26 41.5C26 51.7152 34.2848 60 44.5 60C54.7152 60 63 51.7152 63 41.5C63 31.2848 54.7152 23 44.5 23ZM43.2933 51.3904C42.9027 51.7804 42.27 51.7801 41.8797 51.3898L33.823 43.3331C33.4328 42.9429 33.4325 42.3103 33.8223 41.9196L36.4277 39.3089C36.8181 38.9177 37.4518 38.9173 37.8426 39.3082L41.8785 43.344C42.2693 43.7348 42.9029 43.7345 43.2933 43.3434L51.8457 34.7768C52.2362 34.3857 52.8698 34.3855 53.2605 34.7762L55.8881 37.4038C56.2789 37.7945 56.2786 38.4282 55.8875 38.8186L43.2933 51.3904Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_4281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7);
export default __webpack_public_path__ + "static/media/step-7.3b3e6534c9716ca770708516af9c3385.svg";
export { ForwardRef as ReactComponent };